import { useAnnouncements } from "../lib/announcements";

export function AnnouncementBanner() {
  const { undismissed, dismiss } = useAnnouncements();

  if (undismissed.length === 0) return null;

  return (
    <div className="announcement-fixed" role="region" aria-label="Announcements">
      {undismissed.map((a) => (
        <div key={a.id} className={`announcement-banner ${a.type}`}>
          <div className="announcement-body">
            <span className="announcement-title">{a.title}</span>
            {a.body && <span className="announcement-text">{a.body}</span>}
          </div>
          <button
            className="announcement-dismiss"
            onClick={() => dismiss(a.id)}
            aria-label="Dismiss"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
